import { cx } from '@linaria/core';
import { useRef, useState, useCallback } from 'react';
import { resets } from '@ui/css';
import { debounce } from '@utils/common';
import { SearchIcon } from '../../icons/search.js';
import { inputIconWrapper, iconCls, crossIcon, iconButton, crossIconWrapper, input, globalThemeSearchButton, inputWrapper, modifiers } from './search.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Tooltip } from '../overlays/tooltip/tooltip.js';

function Search(props) {
  const fallbackInputRef = useRef(null);
  const inputRef = props.inputRef ?? fallbackInputRef;
  const [internalQuery, setInternalQuery] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedQueryChange = useCallback(debounce(props.onQueryChange, props.debounceMs ?? props.theme === "global" ? 350 : 0), [props.onQueryChange, props.debounceMs]);
  const handleQueryChange = newValue => {
    setInternalQuery(newValue);
    debouncedQueryChange(newValue);
  };
  const onKeyDown = evt => {
    if (internalQuery && evt.key === "Escape") {
      evt.stopPropagation();
      setInternalQuery("");
      debouncedQueryChange("");
    }
  };
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: cx(resets.rootCls, inputWrapper, props.className, props.compact && modifiers.compact.className, internalQuery.length > 0 && modifiers.filled.className),
    "data-theme": props.theme,
    children: [/*#__PURE__*/jsxs("div", {
      className: inputIconWrapper,
      children: [/*#__PURE__*/jsx(SearchIcon, {
        onClick: () => inputRef.current?.focus(),
        className: iconCls
      }), /*#__PURE__*/jsx(Tooltip, {
        placement: "top",
        body: "Ryd",
        ariaType: undefined,
        offsetPx: -25,
        disabled: internalQuery.length === 0,
        children: ref => /*#__PURE__*/jsx("button", {
          ref: ref,
          "aria-hidden": internalQuery.length === 0,
          "aria-label": "Ryd søgning",
          onClick: () => {
            handleQueryChange("");
            inputRef.current?.focus();
          },
          className: cx(iconCls, iconButton, crossIconWrapper),
          disabled: internalQuery.length === 0,
          children: /*#__PURE__*/jsx("div", {
            className: crossIcon
          })
        })
      })]
    }), /*#__PURE__*/jsx("input", {
      ref: inputRef,
      className: input,
      type: "search",
      onChange: evt => handleQueryChange(evt.target.value),
      onKeyDownCapture: onKeyDown,
      value: internalQuery,
      placeholder: props.placeholder,
      "aria-label": props["aria-label"]
    }), props.theme === "global" && /*#__PURE__*/jsx("button", {
      className: globalThemeSearchButton,
      children: "S\xF8g"
    })]
  });
}

export { Search };
//# sourceMappingURL=search.js.map
